/**
 * Identité produit — source unique pour l’UI publique (login, meta, loaders).
 * Couleurs : charte graphique FUNTOA (CMJN → hex web).
 */
export const PLATFORM_BRANDING = {
  NAME: 'FUNTOA eHealth+',
  NAME_PARTS: {
    PRIMARY: 'FUNTOA',
    ACCENT: 'eHealth+'
  },
  SHORT_NAME: 'FUNTOA',
  TAGLINE: 'Plateforme de santé au travail',
  DESCRIPTION:
    'Gestion des adhérents, consultations, pharmacie et prise en charge médicale inter-entreprises.',
  LOGO_SRC: '/logo.png',
  /** Logo horizontal officiel (FUNTOA + SMIE) — header admin, documents */
  LOGO_WORDMARK_SRC: '/logo%20FUNTOA.png',
  LOGO_ALT: 'FUNTOA eHealth+ — plateforme de santé au travail',
  LOGO_WORDMARK_ALT: 'FUNTOA — Service Médical Interentreprise',
  FONTS: {
    DISPLAY: 'Montserrat',
    BODY: 'Poppins'
  },
  COLORS: {
    PRIMARY: '#0019ff',
    PRIMARY_BRIGHT: '#000df2',
    PRIMARY_DARK: '#00008f',
    PRIMARY_DEEP: '#000050',
    SKY: '#4dd9ff',
    YELLOW: '#ffe60d',
    ORANGE: '#ff8000',
    GREEN: '#26e600',
    GRAY_700: '#4d4d4d',
    GRAY_100: '#f2f2f2'
  },
  HIGHLIGHTS: [
    'Parcours médical et infirmerie',
    'Adhérents et sociétés affiliées',
    'Pharmacie et tarification SMIE'
  ],
  LOGIN: {
    TITLE: 'Connexion',
    SUBTITLE: 'Accédez à votre espace professionnel sur la plateforme.',
    FOOTER: 'Accès réservé au personnel autorisé FUNTOA eHealth+.',
    SECURE_HINT: 'Connexion sécurisée et chiffrée'
  },
  copyright() {
    return `© ${new Date().getFullYear()} ${this.NAME}. Tous droits réservés.`;
  }
};
